import React from 'react';
import MediaLibraryHeroImage from 'src/assets/icons/media-library-hero.svg';
import {FileUpload} from 'src/ui-components/FileUpload/FileUpload';

const MediaNoContent = ({onFileDrop, showGettingStarted}: any) => {
    const onFileAdd = (files: FileList) => {
        onFileDrop(files);
    };
    return (
        <section className='px-10 pb-[62px]'>
            {showGettingStarted && (
                <>
                    <div className='items-center] mt-[-55px] flex justify-center'>
                        <img src={MediaLibraryHeroImage} alt='mediaLibraryHero' height={350} width={525} />
                    </div>
                    <div className='mb-10 flex flex-col items-center justify-center'>
                        <span className='text-[18px] font-[700] text-[#101828]'>Upload your first image</span>
                        <span className='text-[18px] font-[400] text-[#475467]'>
                            Get started by adding first image on PerceptPixel
                        </span>
                    </div>
                </>
            )}
            <div>
                <FileUpload onUpload={onFileAdd} className='h-[500px] w-full' />
            </div>
        </section>
    );
};

export default MediaNoContent;
